import { DeleteContractResponseContent } from '@/types/contract.types';
import { createApiRequest } from "../common";

export const deleteContractApi = async (
  contractId: string
): Promise<DeleteContractResponseContent> => {
  const request = createApiRequest<DeleteContractResponseContent>('post', '/deleteContract');
  return request({ contractId });
};